// Report metadata the API does not return yet. Mode, scope and the inspection basis become live values with AVA-535.
// Copy mirrors the approved showcase (src/assets/showcase/ai-analysis-report-showcase.html).
export const REPORT_TITLE = 'AVA AI Inspection Report';
export const REPORT_MODE = 'High Accuracy Mode';
/** Shown instead of an em-dash where the API returns nothing, so a blank is not read as "none". */
export const NOT_RECORDED = 'Not recorded';
export const REPORT_SCOPE = 'ALL COMPONENTS';
export const PROPOSED_LABEL = 'Proposed';

export const INSPECTION_BASIS = Object.freeze([
  { label: 'Code / Standard:', value: 'BS EN ISO 4628-3:2016 rust grades (Ri0–Ri5), applied per patch' },
  { label: 'Assessment Method:', value: 'Visual AI assessment — external corrosion on 360° scan imagery' },
  { label: 'Coating Condition:', value: 'Per Energy Institute external corrosion guidance' },
  { label: 'Environment:', value: 'Marine — offshore (C5-M)' },
  { label: 'Recommendation:', value: 'Inspector to verify all findings; UT / CWT where scab measure is YES' },
]);

export const CONTOUR_LEGEND = Object.freeze([
  { bucket: 'high', label: 'High confidence — 85% and above' },
  { bucket: 'moderate', label: 'Moderate confidence — 70–84%' },
  { bucket: 'low', label: 'Low confidence — below 70%' },
]);

export const SCAB_LEGEND = Object.freeze([
  { value: 'YES', label: 'Likely raised scab — measure recommended' },
  { value: 'POSSIBLE', label: 'Possible raised scab — verify and consider measure' },
  { value: 'NO', label: 'No raised scab indicated' },
]);

export const VALIDATION_PENDING = Object.freeze({
  icon: 'mdi-alert',
  lead: 'All findings and this report are ',
  emphasis: 'PROPOSED',
  trail: ' and require inspector review and validation.',
  foot: 'Review required before acceptance.',
});

export const VALIDATION_APPROVED = Object.freeze({
  icon: 'mdi-check-decagram',
  lead: 'Reviewed. Every finding carries an inspector decision. Accepted findings are added to AI Inspect; rejected findings are removed from the report.',
  emphasis: '',
  trail: '',
  foot: 'Ri and category remain provisional per-patch values.',
});

/** PDF page 1, right column, under the annotated scan - the reference's "Validation status / contour limitation". */
export const PDF_CONTOUR_LIMITATION =
  "Finding outlines are drawn by the AI from its own detection; outline confidence is lower where an edge is unclear. Ri and category are provisional per patch, never the inspection RI.";
export const PDF_NO_INFERENCE = 'No wall loss, depth, scab height, remaining thickness or cm2 area has been inferred.';
export const PDF_DETAIL_TITLE = 'Detailed Findings & Validation';

export const REPORT_NOTES = Object.freeze([
  'Report mode, scope and the Inspection basis are the standard values for this report type, not measurements taken on this asset.',
  'Contours indicate coating breakdown / corrosion; Ri and category are provisional per patch, never the inspection RI.',
  'Area metric = relative visible area (%) of the image; perspective is not corrected.',
  'Rejected findings are removed from the report and from the summary figures.',
]);

export const RI_TOOLTIP = 'Provisional Ri — per patch, not the inspection RI';
export const CAT_TOOLTIP = 'Provisional category (Cat A–D), shown as the letter';
export const CONFIDENCE_TOOLTIP = 'Corrosion detection confidence';
export const AREA_TOOLTIP = 'Relative visible area — share of the image (%)';
export const SCAB_CONFIDENCE_TOOLTIP = 'Scab measure confidence';
export const EDIT_AREAS_TOOLTIP = 'Coming soon';
/* Component (master tag) link - approved showcase ai-analysis-tag-picker-showcase.html, option B. */
export const NOT_LINKED_LABEL = 'Not linked';
export const NOT_LINKED_FIELD_LABEL = 'Not linked — choose a component';
export const COMPONENT_HINT = 'The finding is grouped and reported under this component. Change it any time; Remove clears it.';
export const SUGGESTED_FROM = 'from the AVA Inspect';
export const COMPONENT_SEARCH_PLACEHOLDER = 'Search components by name';
export const COMPONENT_NO_ACCESS = 'You do not have access to the component list.';
export const COMPONENT_LOAD_FAILED = 'The component list could not be loaded. Please try again.';
export const UNLINKED_GROUP_HINT = 'Select findings and use Link to component, or click a cell in the Component column.';
export const AREA_DECIMALS = 2;
export const DATE_FORMAT = 'DD MMM YYYY HH:mm';
export const SHOW_ON_SCAN_LABEL = 'Show on scan';
export const FINDING_REPORT_MOCK_MESSAGE = 'The finding report is not available in demo mode.';
